import mg12 from '../assets/img/portfolio-mg12.png'
import evo from '../assets/img/portfolio-evo.png'
import adnova from '../assets/img/portfolio-adnova.png'
import storycast from '../assets/img/portfolio-storycast.jpg'
import smoothaffairs from '../assets/img/portfolio-smoothaffairs.jpg'
import connectprint from '../assets/img/portfolio-cp.png'
import premiumservices from '../assets/img/portfolio-ps.jpg'
import tomov from '../assets/img/portfolio-tomov.png'

const portfolio = [
    {
        title: "Tomov Dental",
        href: "https://dl-dental.com",
        imageSrc: tomov
    },
    {
        title: "Storycast",
        href: "https://storycast.bg",
        imageSrc: storycast
    },
    {
        title: "Adnova",
        href: "https://adnova.vercel.app",
        imageSrc: adnova
    },
    {
        title: "Premium Services",
        href: "https://premiumservices.netlify.app/",
        imageSrc: premiumservices
    },
    {
        title: "Smooth Affairs",
        href: "https://smoothaffairs.netlify.app/",
        imageSrc: smoothaffairs,
    },
    {
        title: "ConnectPrint",
        href: "https://connectprint.net",
        imageSrc: connectprint
    },
    {
        title: "Mgnesium12",
        href: "https://mgnesium12.com",
        imageSrc: mg12
    },
    {
        title: "Ivaylo Ivanov Portfolio",
        href: "http://storyou.bg",
        imageSrc: evo
    }
]

export default portfolio;